module.exports = __webpack_public_path__ + "media/images/sp/stores/tachikawa/tachikawa_sns_05-43376cea9a254c8c621a28392bbd5cdb.jpg";